import React from 'react';
import { formatExactMoney } from '../../data/countries';

const CostDonutChart = ({
  segments,
  total,
  country,
  centerLabel,
  centerHint = "Total",
  compact = false,
  ariaLabel = "Cost breakdown",
  formatValue = (n) => formatExactMoney(n, country),
}) => {
  const rows = (segments || []).filter((s) => Number(s.value) > 0);
  if (!total || total <= 0 || !rows.length) return null;
  const size = compact ? 152 : 188;
  const stroke = compact ? 11 : 14;
  const r = (size - stroke) / 2 - 1;
  const cx = size / 2;
  const cy = size / 2;
  const circ = 2 * Math.PI * r;
  const rot = -90;
  let offset = 0;
  return (
    <div className={`rent-cost-donut-wrap${compact ? " rent-cost-donut-wrap--compact" : ""}`}>
      <div className="rent-cost-donut-chart" style={{ width: size, height: size }}>
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img" aria-label={ariaLabel}>
          <circle cx={cx} cy={cy} r={r} fill="none" stroke="rgba(11, 31, 42, 0.12)" strokeWidth={stroke} />
          {rows.map((seg, i) => {
            const len = circ * Math.min(1, Math.max(0, seg.value / total));
            const dash = `${len} ${circ - len}`;
            const el = (
              <circle
                key={`${seg.label}-${i}`}
                cx={cx}
                cy={cy}
                r={r}
                fill="none"
                stroke={seg.color}
                strokeWidth={stroke}
                strokeDasharray={dash}
                strokeDashoffset={-offset}
                transform={`rotate(${rot} ${cx} ${cy})`}
              />
            );
            offset += len;
            return el;
          })}
        </svg>
        <div className="rent-cost-donut-center">
          <strong>{centerLabel ?? formatValue(total)}</strong>
          <span>{centerHint}</span>
        </div>
      </div>
      <ul className="rent-cost-donut-legend">
        {rows.map((seg, i) => (
          <li key={`${seg.label}-${i}`}>
            <span className={`rent-cost-donut-swatch${seg.swatchClass ? ` ${seg.swatchClass}` : ""}`} style={seg.swatchClass ? undefined : { background: seg.color }} aria-hidden="true"></span>
            <span>{seg.label}</span>
            <span>{formatValue(seg.value)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CostDonutChart;
